export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-3-204a0160b42a0a7ce4d810513f5cd274.jpg";